import HeadingMedium from "./HeadingMedium";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function ProductName({ name, brand }) {
  return (
    <>
      <Text
        lineHeight={[1, null, "26px", null]}
        fontSize={[14, 14, 16, 16]}
        uppercase
        fontWeight={700}
        mb="10px"
      >
        {brand}
      </Text>
      <HeadingMedium as="h1" uppercase>
        {name}
      </HeadingMedium>
    </>
  );
}

export default ProductName;

ProductName.propTypes = {
  name: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};
